import $43CnS$intltreearAEmjs from "../intl/tree/ar-AE.mjs";
import $43CnS$intltreebgBGmjs from "../intl/tree/bg-BG.mjs";
import $43CnS$intltreecsCZmjs from "../intl/tree/cs-CZ.mjs";
import $43CnS$intltreedaDKmjs from "../intl/tree/da-DK.mjs";
import $43CnS$intltreedeDEmjs from "../intl/tree/de-DE.mjs";
import $43CnS$intltreeelGRmjs from "../intl/tree/el-GR.mjs";
import $43CnS$intltreeenUSmjs from "../intl/tree/en-US.mjs";
import $43CnS$intltreeesESmjs from "../intl/tree/es-ES.mjs";
import $43CnS$intltreeetEEmjs from "../intl/tree/et-EE.mjs";
import $43CnS$intltreefiFImjs from "../intl/tree/fi-FI.mjs";
import $43CnS$intltreefrFRmjs from "../intl/tree/fr-FR.mjs";
import $43CnS$intltreeheILmjs from "../intl/tree/he-IL.mjs";
import $43CnS$intltreehrHRmjs from "../intl/tree/hr-HR.mjs";
import $43CnS$intltreehuHUmjs from "../intl/tree/hu-HU.mjs";
import $43CnS$intltreeitITmjs from "../intl/tree/it-IT.mjs";
import $43CnS$intltreejaJPmjs from "../intl/tree/ja-JP.mjs";
import $43CnS$intltreekoKRmjs from "../intl/tree/ko-KR.mjs";
import $43CnS$intltreeltLTmjs from "../intl/tree/lt-LT.mjs";
import $43CnS$intltreelvLVmjs from "../intl/tree/lv-LV.mjs";
import $43CnS$intltreenbNOmjs from "../intl/tree/nb-NO.mjs";
import $43CnS$intltreenlNLmjs from "../intl/tree/nl-NL.mjs";
import $43CnS$intltreeplPLmjs from "../intl/tree/pl-PL.mjs";
import $43CnS$intltreeptBRmjs from "../intl/tree/pt-BR.mjs";
import $43CnS$intltreeptPTmjs from "../intl/tree/pt-PT.mjs";
import $43CnS$intltreeroROmjs from "../intl/tree/ro-RO.mjs";
import $43CnS$intltreeruRUmjs from "../intl/tree/ru-RU.mjs";
import $43CnS$intltreeskSKmjs from "../intl/tree/sk-SK.mjs";
import $43CnS$intltreeslSImjs from "../intl/tree/sl-SI.mjs";
import $43CnS$intltreesrSPmjs from "../intl/tree/sr-SP.mjs";
import $43CnS$intltreesvSEmjs from "../intl/tree/sv-SE.mjs";
import $43CnS$intltreetrTRmjs from "../intl/tree/tr-TR.mjs";
import $43CnS$intltreeukUAmjs from "../intl/tree/uk-UA.mjs";
import $43CnS$intltreezhCNmjs from "../intl/tree/zh-CN.mjs";
import $43CnS$intltreezhTWmjs from "../intl/tree/zh-TW.mjs";

var $36b40d6961d38896$exports = {};


































$36b40d6961d38896$exports = {
    "ar-AE": $43CnS$intltreearAEmjs,
    "bg-BG": $43CnS$intltreebgBGmjs,
    "cs-CZ": $43CnS$intltreecsCZmjs,
    "da-DK": $43CnS$intltreedaDKmjs,
    "de-DE": $43CnS$intltreedeDEmjs,
    "el-GR": $43CnS$intltreeelGRmjs,
    "en-US": $43CnS$intltreeenUSmjs,
    "es-ES": $43CnS$intltreeesESmjs,
    "et-EE": $43CnS$intltreeetEEmjs,
    "fi-FI": $43CnS$intltreefiFImjs,
    "fr-FR": $43CnS$intltreefrFRmjs,
    "he-IL": $43CnS$intltreeheILmjs,
    "hr-HR": $43CnS$intltreehrHRmjs,
    "hu-HU": $43CnS$intltreehuHUmjs,
    "it-IT": $43CnS$intltreeitITmjs,
    "ja-JP": $43CnS$intltreejaJPmjs,
    "ko-KR": $43CnS$intltreekoKRmjs,
    "lt-LT": $43CnS$intltreeltLTmjs,
    "lv-LV": $43CnS$intltreelvLVmjs,
    "nb-NO": $43CnS$intltreenbNOmjs,
    "nl-NL": $43CnS$intltreenlNLmjs,
    "pl-PL": $43CnS$intltreeplPLmjs,
    "pt-BR": $43CnS$intltreeptBRmjs,
    "pt-PT": $43CnS$intltreeptPTmjs,
    "ro-RO": $43CnS$intltreeroROmjs,
    "ru-RU": $43CnS$intltreeruRUmjs,
    "sk-SK": $43CnS$intltreeskSKmjs,
    "sl-SI": $43CnS$intltreeslSImjs,
    "sr-SP": $43CnS$intltreesrSPmjs,
    "sv-SE": $43CnS$intltreesvSEmjs,
    "tr-TR": $43CnS$intltreetrTRmjs,
    "uk-UA": $43CnS$intltreeukUAmjs,
    "zh-CN": $43CnS$intltreezhCNmjs,
    "zh-TW": $43CnS$intltreezhTWmjs
};


export {$36b40d6961d38896$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
